"use client";

import { useEffect } from "react";
import {
  FaInstagram,
  FaWhatsapp,
  FaPhoneAlt,
  FaEnvelope,
  FaTiktok
} from "react-icons/fa";
import logo from "../assets/logo/logo.ico"; 

export default function Footer() {
  const quickLinks = [
    { name: "Home", href: "/" },
    { name: "Shop", href: "/products" },
    { name: "About Us", href: "/about-us" },
    { name: "Contact", href: "/contact-us" },
    { name: "Privacy Policy", href: "#" },
  ];

 const socialLinks = [
  { 
    icon: <FaInstagram />, 
    name: "Instagram", 
    href: "https://www.instagram.com/imransonstraders?igsh=Z2xhbWpkcW0xeGJt&utm_source=qr" 
  },
  { 
    icon: <FaWhatsapp />, 
    name: "WhatsApp", 
    href: "https://wa.me/447956575153" 
  },
  { 
    icon: <FaTiktok />, 
    name: "TikTok", 
    href: "https://www.tiktok.com/@imran.sonstrader" 
  },
];


  // 🌟 Floating Particles Animation (Canvas)
  useEffect(() => {
    const canvas = document.getElementById("footerCanvas");
    if (!canvas) return;
    const ctx = canvas.getContext("2d");

    const resizeCanvas = () => {
      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
    };

    resizeCanvas();
    window.addEventListener("resize", resizeCanvas);

    let particles = [];
    const createParticles = () => {
      particles = [];
      for (let i = 0; i < 90; i++) { // 💫 increased from 35 → 90
        particles.push({
          x: Math.random() * canvas.width,
          y: Math.random() * canvas.height,
          size: Math.random() * 3 + 1,
          speedY: Math.random() * 0.6 + 0.3,
          color: "rgba(168, 124, 79, 0.45)",
        });
      }
    };

    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      particles.forEach((p) => {
        p.y += p.speedY;
        if (p.y > canvas.height) {
          p.y = 0;
          p.x = Math.random() * canvas.width;
        }
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
        ctx.fillStyle = p.color;
        ctx.fill();
      });
      requestAnimationFrame(animate);
    };

    createParticles();
    animate();

    return () => window.removeEventListener("resize", resizeCanvas);
  }, []);

  return (
    <footer className="relative overflow-hidden bg-[#f8f4ee] text-[#3a2b1f] py-12 px-6 sm:px-10 md:px-16 border-t border-[#d8c7b5]">
      {/* 🌟 Canvas Background Animation */}
      <canvas
        id="footerCanvas"
        className="absolute top-0 left-0 w-full h-full opacity-30 pointer-events-none"
      ></canvas>

      {/* 🌴 Floating Palm Emojis (more and smoother) */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none z-0">
        {[...Array(12)].map((_, i) => ( // 🌴 increased from 4 → 12
          <span
            key={i}
            className="absolute text-2xl animate-[float_7s_ease-in-out_infinite] opacity-40"
            style={{
              top: `${Math.random() * 90}%`,
              left: `${Math.random() * 95}%`,
              animationDelay: `${i * 0.5}s`,
            }}
          >
            🌴
          </span>
        ))}
      </div>

      {/* Top Section */}
      <div className="relative z-10 flex flex-col md:flex-row justify-between gap-12 md:gap-20">
{/* Logo & About */}
<div className="flex-1">
  <div className="flex items-center gap-2 mb-4">

    {/* Rounded Logo Image */}
    <img
      src={logo} // same import as header
      alt="Imran & Sons Traders Logo"
      className="h-8 w-8 md:h-10 md:w-10 object-cover rounded-full border border-[#D4AF37]"
    />

    <h2 className="text-xl font-semibold tracking-wide">
      Imran & Sons Traders
    </h2>
  </div>

  <p className="text-sm text-[#4b3d31] leading-relaxed">
    🌴 <b>Premium Saudi Dates</b> – fresh, natural & full of energy.
    Wholesale & retail available.
  </p>

  <p className="mt-3 text-sm text-[#4b3d31] leading-relaxed">
    At <b>Imran & Sons Traders</b>, we bring you the finest quality Saudi dates
    (Madinah Al Munawwarah), freshly handpicked from fertile farms. Our
    dates & attar are 100% natural, rich in nutrients, and carefully
    packed to preserve freshness and aroma.
  </p>
</div>



        {/* Quick Links */}
        <div className="flex-1 min-w-[160px]">
          <h3 className="font-semibold text-lg mb-4 border-b-2 border-[#a87c4f] w-fit">
            Quick Links
          </h3>
          <ul className="space-y-2">
            {quickLinks.map((link) => (
              <li key={link.name}>
                <a
                  href={link.href}
                  className="text-sm hover:text-[#a87c4f] transition duration-200"
                >
                  {link.name}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact Info */}
        <div className="flex-1 min-w-[200px]">
          <h3 className="font-semibold text-lg mb-4 border-b-2 border-[#a87c4f] w-fit">
            Contact Us
          </h3>
          <ul className="space-y-3 text-sm">
            <li className="flex items-center gap-2">
              <FaEnvelope className="text-[#a87c4f]" /> imranandsonstraders@gmail.com
            </li>
            <li className="flex items-center gap-2">
              <FaPhoneAlt className="text-[#a87c4f]" /> +44 7956 575153
            </li>
          </ul>

          {/* Social Icons */}
          <div className="flex gap-4 mt-5">
            {socialLinks.map((social) => (
            <a
  key={social.name}
  href={social.href}
  aria-label={social.name}
  target="_blank"
  rel="noopener noreferrer"
  className="text-[#3a2b1f] text-lg hover:text-[#a87c4f] transition"
>
  {social.icon}
</a>

            ))}
          </div>
        </div>
      </div>

 {/* Bottom Bar */}
<div className="relative z-10 border-t border-[#d8c7b5] mt-12 pt-6 flex flex-col sm:flex-row justify-between items-center text-sm text-[#4b3d31]">
  <p className="text-center sm:text-left">
    &copy; {new Date().getFullYear()} Imran & Sons Traders. All rights reserved.
  </p>
  <p className="text-center sm:text-right mt-2 sm:mt-0">
    Designed with 🌴 by <b>Date Tree</b>
  </p>
</div>


      {/* Inline Keyframes */}
      <style>{`
        @keyframes float {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-20px);
          }
        }
      `}</style>
    </footer>
  );
}
